import { render, staticRenderFns } from "./customersPage.vue?vue&type=template&id=46b3d103&"
import script from "./customersPage.vue?vue&type=script&lang=ts&"
export * from "./customersPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports